import { graphql } from "gql";

const INTERNAL_ADMIN_CREATE_USER_ATTRIBUTE_MUTATION = graphql(`
  mutation InternalAdminCreateUserAttribute(
    $organizationId: ID!
    $input: AdminCreateUserAttributeInput!
  ) {
    internalAdminCreateUserAttribute(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminUserAttribute
    }
  }
`);

export default INTERNAL_ADMIN_CREATE_USER_ATTRIBUTE_MUTATION;
